export const colorSchemeCookieName = 'color-scheme';
export const colorSchemeDataName = 'colorScheme';

export const colorSchemeAttributeName = `data-color-scheme`;

export const COLOR_SCHEMES = ['light', 'dark'] as const;
export type ColorScheme = (typeof COLOR_SCHEMES)[number];
